import './manager-icon.styles.scss';
import { useContext } from 'react';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ShowManagersContext } from '@/utils/managers';

// A small user icon after a team a user manages (team: a summary/teams
// row). Shows only where ShowManagersContext is on.
const ManagerIcon = ({ team }) => {
    const show = useContext(ShowManagersContext);
    if (!show || !team?.managerId) return null;
    const label = `Managed by ${team.managerName ?? 'a user'}`;
    return (
        <span className='manager-icon' title={label} aria-label={label} role='img'>
            <FontAwesomeIcon icon={faUser} />
        </span>
    );
}

export default ManagerIcon
